export const EstadoPlanAccionEvaluacion = {
    PENDIENTE: "PENDIENTE",
    CERRADO: "CERRADO",
    CERRADO_FUERA_PLAZO:"CERRADO_FUERA_PLAZO"
}